export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M11.134 17.875a1 1 0 0 0 1.732 0l6.062-10.5a1 1 0 0 0-.866-1.5H5.938a1 1 0 0 0-.866 1.5l6.062 10.5Z"/>
</svg>
`;
